import { LocalParticipant } from "twilio-video";
import { removeLocalParticipantTracks } from "./removeLocalParticipantTracks";

export const unpublishVideoTrack = (localParticipant: LocalParticipant) => {
  const tracks = Array.from(localParticipant.videoTracks.values()).map(
    (tr) => tr.track,
  );
  removeLocalParticipantTracks(localParticipant, tracks);
};
